import { GlobalVariables } from '../../constants/globals';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { format, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { ValueAdapter } from '../adapters/value.adapter';
import { IAttribute, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ServiceNowV2ObjectDataset } from '../dataset/servicenow-v2.dataset';
import { ModelConstants } from '../model-constants';
import { QueryExpression } from '../pipeline/query-expression';
import { QueryOperator } from '../query-expression.constants';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: ModelConstants.serviceNowV2CopySource,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(ServiceNowV2ObjectDataset) }
})
export class ServiceNowV2CopySource extends TabularCopySource {
    public static readonly EXPRESSION: IAttribute;
    public static readonly PAGESIZE: IAttribute;
    public static readonly SELECTCOLUMNS: IAttribute;
    public static readonly PARTITIONOPTION: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'EXPRESSION',
        constraint: {
            validator: ServiceNowV2CopySource.expressionValidator
        }
    })
    public expression?: QueryExpression[];

    @Metamodel.attribute({
        templatable: true,
        association: 'PAGESIZE',
        display: shellStringResources.PageSizeLabel,
        constraint: {
            minimum: 1
        }
    })
    public pageSize?: number = 300;

    @Metamodel.attribute({
         display: shellStringResources.ModelName_Partition_Option,
         association: 'PARTITIONOPTION',
         templatable: true
     })
     public partitionOption?: string = GlobalVariables.enableServiceNowV2Partition ?  'None': undefined;

    @Metamodel.attribute({
        templatable: true,
        association: 'SELECTCOLUMNS',
        display: shellStringResources.ServiceNowSelectLabel,
    })
    public selectColumns?: string[];

    public static expressionValidator(entity: ServiceNowV2CopySource): IViolation[] | undefined {
        if (!entity.expression) {
            return undefined;
        }

        const violations: IViolation[] = [];
        const missingValue = (val: string, obj: {}, attr: IAttribute): boolean => {
            return stringIsNullOrEmpty(val) && !ValueAdapter.isTemplated(obj, attr);
        };

        entity.expression?.forEach((exp) => {
            if (!Object.values(QueryOperator).includes(exp.operator)) {
                violations.push({
                    context: exp,
                    message: () => shellStringResources.ServiceNow_UnsupportedOperator_ErrorMessage
                });
            }
            if (stringIsNullOrEmpty(exp.column)) {
                violations.push({
                    context: entity.expression,
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.ColumnNameLabel)
                });
            }
            if (missingValue(exp.value, exp, QueryExpression.VALUE) ||
                exp.operator === QueryOperator.between && missingValue(exp.additionalValue, exp, QueryExpression.VALUE2)) {
                violations.push({
                    context: entity.expression,
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.Value)
                });
            }
        });

        return violations.length === 0 ? undefined : violations;
    }
}
